<template>
  <v-container fluid class="viewLicence pa-0" v-if="$route.name !== 'Licences'">
    <div class="breadcrumHeader d-flex">
      <v-breadcrumbs :items="['licences']" dense divider="/">
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item
              @click="(isDrilldown = false), $router.push('/licences')"
              style="cursor: pointer; font-weight:400"
            >
              <h4>Licences</h4>
            </v-breadcrumbs-item>
            <v-breadcrumbs-item>
              <h2 style="color: #000; font-weight:400"
                >/View Details</h2
              >
            </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
    </div>
    <div class="px-5">
      <v-row>
        <v-col>
          <div class="card px-5 pt-5 pb-3">
            <div class="line-after">
              <p>Profile Details:</p>
            </div>
            <v-row>
              <v-col md="5">
                <div class="profileDetails">
                  <span>Name:</span>
                  <p>{{name}}</p>
                </div>
              </v-col>
              <v-col md="5">
                <div class="profileDetails">
                  <span>Email:</span>
                  <p>{{primaryEmail}}</p>
                </div>
              </v-col>
              <v-col md="2">
                <div class="profileDetails">
                  <span>Company:</span>
                  <p>{{orgName}}</p>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <div class="card px-5 pt-5 pb-3">
            <div class="line-after">
              <p class="mb-2">Analytics:</p>
            </div>
            <v-row class="custom-infocards">
              <v-col md="4">
            <div class="infoCard px-3 py-6 text-center">
              <p class="subtitle-1">
                <v-icon color="green" size="20px">bar_chart</v-icon>
                No of metrics added
              </p>
              <div class="h6">{{ metrics }}</div>
            </div>
          </v-col>
          <v-col md="4">
            <div class="infoCard px-3 py-6 text-center">
              <p class="subtitle-1">
                <v-icon color="indigo" size="20px">electrical_services</v-icon>
                No of connectors configured
              </p>
              <div class="h6">{{ connectors }}</div>
            </div>
          </v-col>
          <v-col md="4">
            <div class="infoCard px-3 py-6 text-center">
              <p class="subtitle-1">
                <v-icon color="teal darken-1" size="20px">assignment_turned_in</v-icon>
                No of programs active
              </p>
              <div class="h6">{{ programs }}</div>
            </div>
          </v-col>
          <v-col md="4">
            <div class="infoCard px-3 py-6 text-center">
              <p class="subtitle-1">  
                <v-icon color="light-blue darken-1" size="20px">data_exploration</v-icon>
                No of VSM's created
              </p>
              <div class="h6">{{ vsms }}</div>
            </div>
          </v-col>
          <v-col md="4">
            <div class="infoCard px-3 py-6 text-center">
              <p class="subtitle-1">
                <v-icon color="purple lighten-1" size="20px">sticky_note_2</v-icon>
                No of Projects being monitored
              </p>
              <div class="h6">{{ projects }}</div>
            </div>
          </v-col>
          <v-col md="4">
            <div class="infoCard px-3 py-6 text-center">
              <p class="subtitle-1">
                <v-icon color="pink lighten-2" size="20px">contact_page</v-icon>
                No of Client accounts set up
              </p>
              <div class="h6">{{ Clients }}</div>
            </div>
          </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
    </div>
    <v-row>
      <v-col>
        <v-card class="tierDetails">
          <div class="card1 px-5 pt-5">
            <div class="line-after mb-3">
              <p>Tier Details</p>
            </div>
            <div class="px-3">
           <v-row>
              <v-col class="tierInfo">
                <p>Tier</p>
                <h6>{{ tierName }}</h6>
              </v-col>
              <v-col class="tierInfo">
                <p>Start Date</p>
                <h6>{{ moment(dateSubscribed) }}</h6>
              </v-col>
              <v-col class="tierInfo">
                <p>End Date</p>
                <h6>{{ moment(validTo) }}</h6>
              </v-col>
              <v-col class="tierInfo">
                <p>Total Number of Users</p>
                <h6>{{ product1Users + product2Users }}</h6>
              </v-col>
              <v-col class="tierInfo">
                <p>Status</p>
                <v-chip v-if="!isExpired && isActive">
                  <v-icon left> mdi-check-circle </v-icon>
                  Active
                </v-chip>
                <v-chip v-if="isExpired" color="red" class="expiredchip">
                  <span style="color: #fff !important">Expired</span>
                </v-chip>
              </v-col>
            </v-row>
          </div>
          </div>
          <div class="card2">
            <v-row class="custom-simple-table">
              <v-col>
                <v-simple-table>
                  <thead>
                    <tr>
                      <th class="text-left"> Tier </th>
                      <th class="text-left"> Product Name </th>
                      <th class="text-left"> Number Of Users </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td rowspan="4">{{ tierName }}</td>
                    </tr>
                    <tr>
                      <td>TED</td>
                      <td>{{ product1Users }}</td>
                    </tr>
                    <tr>
                      <td>MOBE</td>
                      <td>{{ product2Users }}</td>
                    </tr>
                    <tr>
                      <td>PACE</td>
                      <td>0</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-col>
            </v-row>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';
import { storeActions } from '../../store/actions.constants';
export default {
  data: () => ({
    name: '',
    primaryEmail: '',
    orgName: '',
    tierName: '',
    dateSubscribed: '',
    validTo: '',
    product1Name: '',
    product1Users: '',
    product2Name: '',
    product2Users: '',
    isActive: null,
    isExpired: null,
    metrics: '',
    programs: '',
    vsms: '',
    Clients: '',
    connectors: '',
    projects: '',

    items: [
      {
        text: 'Licenses',
        disabled: false,
      },
      {
        text: 'View Licenses',
        disabled: false,
      },
    ],
  }),
  computed: {
    ...mapGetters({
      getCustomerProfile: 'licensees/getCustomerProfile',
    }),
  },
  async mounted() {
    //console.log("id value is",this.$route.params.id)
    let paramsId = this.$route.params.id;
    this.getCustomerProfileByIdInfo(paramsId);
  },
  methods: {
    ...mapActions({
      getCustomerProfileById: 'licensees/getCustomerProfileById',
      getMetricsCount: 'licensees/getMetricsCount',
      getProgramsCount: 'licensees/getProgramsCount',
      getVsmsCount: 'licensees/getVsmsCount',
      getClientsCount: 'licensees/getClientsCount',
      getConnectorsCount: 'licensees/getConnectorsCount',
      getProjectsCount: 'licensees/getProjectsCount',
    }),
    getCustomerProfileByIdInfo(paramsId) {
      this.loading = true;
      const domainObj = {
        id: paramsId,
      };
      this.getCustomerProfileById(domainObj)
        .then((res) => {
          console.log(res.data);
          this.loading = false;
          this.name = res.data.name;
          this.primaryEmail = res.data.primaryEmail;
          this.orgName = res.data.orgName;
          this.isActive = res.data.isActive;
          this.isExpired = res.data.isExpired;
          this.tierName = res.data.tierName;
          this.dateSubscribed = res.data.dateSubscribed;
          this.validTo = res.data.validTo;
          this.product1Name = res.data.usersCount[0].productName;
          this.product1Users = res.data.usersCount[0].count;
          this.product2Name = res.data.usersCount[1].productName;
          this.product2Users = res.data.usersCount[1].count;
        })
        .catch((err) => {
          this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
            text: err.response.data.message,
            timeout: 3000,
            color: 'error',
          });
          this.text = err.message;
          console.error(err);
        });
      this.getMetricsCount(domainObj)
        .then((res) => {
          this.metrics = res.data[0].count;
        })
        .catch((err) => {
          this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
            text: err.response.data.message,
            timeout: 3000,
            color: 'error',
          });
          this.text = err.message;
          console.error(err);
        });
      this.getProgramsCount(domainObj)
        .then((res) => {
          this.programs = res.data[0].count;
        })
        .catch((err) => {
          this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
            text: err.response.data.message,
            timeout: 3000,
            color: 'error',
          });
          this.text = err.message;
          console.error(err);
        });
      this.getVsmsCount(domainObj)
        .then((res) => {
          this.vsms = res.data[0].count;
        })
        .catch((err) => {
          this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
            text: err.response.data.message,
            timeout: 3000,
            color: 'error',
          });
          this.text = err.message;
          console.error(err);
        });
      this.getClientsCount(domainObj)
        .then((res) => {
          this.Clients = res.data[0].count;
        })
        .catch((err) => {
          this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
            text: err.response.data.message,
            timeout: 3000,
            color: 'error',
          });
          this.text = err.message;
          console.error(err);
        });
      this.getConnectorsCount(domainObj)
        .then((res) => {
          this.connectors = res.data[0].count;
        })
        .catch((err) => {
          this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
            text: err.response.data.message,
            timeout: 3000,
            color: 'error',
          });
          this.text = err.message;
          console.error(err);
        });
      this.getProjectsCount(domainObj)
        .then((res) => {
          this.projects = res.data.length > 0 ? res.data[0].count : 0;
        })
        .catch((err) => {
          this.$store.dispatch(`snackbar/${storeActions.setSnackbarText}`, {
            text: err.response.data.message,
            timeout: 3000,
            color: 'error',
          });
          this.text = err.message;
          console.error(err);
        });
    },
    moment: function (value) {
      return moment(value).format('DD MMMM YYYY');
    },
  },
};
</script>


<style lang="scss">
@import '../../assets/scss/colors.scss';
.breadcrumHeader {
  justify-content: space-between;
  padding: 8px 10px 16px 28px;
  background-color: #fff;
  border-bottom: 1px solid #bdbdbd;
  margin: 0 0 15px 0;
  .v-breadcrumbs {
    padding: 0px;
    text-transform: capitalize;
    li:first-child {
      color: #004f96;
    }
    li:nth-child(3) {
      font-size: 16px;
      font-weight: 600;
      color: #121212;
    }
  }
}
.viewLicence {
  background-color: #f7f7f7;
  .card, .card1 {
    background: #fff;
    .line-after {
      position: relative;
      overflow: hidden;
      display: block;
      p {
        vertical-align: baseline;
        display: block;
        position: relative;
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 0px;
        &:after {
          content: '';
          position: absolute;
          width: 100%;
          top: 50%;
          margin-left: 10px;
          border-top: 1px solid #ccc;
        }
      }
    }
    .profileDetails {
      span {
        font-size: 14px;
        font-weight: 600;
        display: inline-block;
        margin-bottom: 4px;
      }
      p {
        font-size: 16px;
        margin-bottom: 0px;
      }
    }
  }
  .v-text-field .v-input__slot {
    border-radius: initial;
  }
  .border-dashed {
    border-style: dashed;
  }
  .tierDetails {
    border-radius: 0px !important;
    box-shadow: none;
    background-color: $secondary-color-6 !important;
    padding: 20px;
    .tierInfo {
      background-color: #f5f5f5;
      border-right: 1px solid #bdbdbd;
      text-align: center;
      padding-top: 20px;
      padding-bottom: 20px;
    }
    .tierInfo:last-child {
      border-right: none;
    }
  }
  .card1 {
    background-color: $white;
    .col {
      p {
        font-size: 14px;
      }
      h6 {
        font-size: 18px;
        font-weight: 500;
      }
    }
  }
  .card2 {
    background-color: $white;
    margin: 0;
    padding: 16px;
    .custom-simple-table {
      padding: 0px 5px;
    }
  }

  .v-chip.v-size--default {
    background-color: $secondary-color-6;
    border-radius: 16px !important;
    height: auto !important;
    color: $secondary-color-7 !important;
    .v-icon {
      margin-left: -12px !important;
      color: $secondary-color-7;
    }
  }
  .expiredchip.v-chip.v-size--default {
    .v-chip__content {
      color: #fff !important;
    }
  }
  .custom-infocards {
    margin-top: -12px;
  }
  .infoCard {
    background-color: #f5f5f5;
    min-height: 90px;
    height: 100%;
    p {
      font-size: 14px !important;
      color: #666;
    }
    div {
      font-size: 24px;
      color: #212121;
      font-weight: 600;
    }
  }
}
</style>